import * as React from 'react';
import moment from 'moment';
import BuyerAppointmentDetail from './BuyerAppointmentDetail';
import { BuyerAppointments } from './types';
import sortAppointments from './sortAppointments';

const supraLogoStyle = {
  maxHeight: '50px',
  margin: '0 0 5px -8px',
};

type BuyerAppointmentsPageProps = {
  appointments: BuyerAppointments;
  showAccessInfo: boolean;
  userName: string;
};

const BuyerAppointmentsPage: React.FunctionComponent<
  BuyerAppointmentsPageProps
> = ({ appointments, showAccessInfo, userName }) => {
  const { groupedAppointmentsByDate, sortedDates } =
    sortAppointments(appointments);
  return (
    <div className="hpanel buyer-appointment-pdf">
      <div
        className="panel-body"
        style={{
          minWidth: '8.5in',
          maxWidth: '8.5in',
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/**
         * Page elements are wrapped in a table because it's one of the
         * only ways to reliably get a header and footer onto each page in
         * print media.
         *
         * This is necessary as unlike in the appointment reportpage, the
         * elements of this pdf can have wildly varying heights, e.g.
         * somebody sending a wall of text in a single message; this way we
         * let print handle the page breaks for us.
         */}
        <table>
          {/* Page header */}
          <thead className="print-header">
            <tr>
              <td>
                <div className="row">
                  <div className="col-xs-7">
                    <h3 style={{ marginTop: '0' }}>
                      <strong>Buyer Showings</strong>
                    </h3>
                  </div>
                  <div className="col-xs-5">
                    <div className="row">
                      <div className="col-xs-6">Created By:</div>
                      <div className="col-xs-6">{userName}</div>
                    </div>
                    <div className="row">
                      <div className="col-xs-6">Date of Report:</div>
                      <div className="col-xs-6">
                        {new Date().toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>

          {/* Page body */}
          <tbody>
            <tr>
              <td>
                {sortedDates.map(date => (
                  <div
                    key={`buyer-showings-section-${date}`}
                    data-cy={`buyer-showings-section-${date}`}
                  >
                    <h5 style={{ padding: '8px 0' }}>
                      <strong>{moment(date).format('ddd, MMM DD YYYY')}</strong>
                    </h5>
                    {groupedAppointmentsByDate[date].map(appointment => (
                      <BuyerAppointmentDetail
                        key={appointment.id}
                        appointment={appointment}
                        showAccessInfo={showAccessInfo}
                      />
                    ))}
                  </div>
                ))}
              </td>
            </tr>
          </tbody>

          {/* Page footer */}
          <tfoot className="print-footer">
            <tr>
              <td>
                <div className="footer-container">
                  <span className="footer-text">Prepared by</span>{' '}
                  <div className="print-logo">
                    <img
                      src="/img/supraLogo.svg"
                      alt="supra-logo"
                      style={supraLogoStyle}
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default BuyerAppointmentsPage;
